export const VAT = 1.24;

// We use the highest advertisement fee of all the sellers as a baseline for the
// ones that specify that the advertisement fee is by agreement.
export const EstimatedAdvertisementFee = 61_876;
